module.exports = __webpack_public_path__ + "static/media/propify.5a17aa3d.png";